import React from 'react'
// import ShapeImg from "../aseets/img/curve.png"
import BannerContautUs from "../aseets/img/contactBanner.png"
// import BannerVideo from "../aseets/video/0_Mountains_Landscape_3840x2160.mp4"
import { Container } from 'react-bootstrap'

const BradCrum = ({Title,ShapeImg,BradCrumImg,color}) => {
  return (
    <React.Fragment>
     
            <div >
            <img className="bannerImgBradCrum" src= {BradCrumImg}alt="banner" />
            {/* <video 
        className="banner-video" 
        autoPlay 
        loop 
        muted 
        playsInline // Ensures compatibility with mobile devices
      >
        <source src={BannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
        </div>
     
           <Container fluid>
      <div className="bannerMainDiv bradeCrumMainDiv">
     
        <div className=" breadSrumTitleDiv ">
        <div className="bannerTitle breadCrumTitle" style={{color:color}}>  {Title}  </div>
    
      
        </div>
      </div>
      </Container>
      <div className="contactUsBanerShapeDiv">
        <img src={ShapeImg} alt="img" />
      </div>
    </React.Fragment>
  )
}

export default BradCrum